module.exports = __webpack_public_path__ + "img/BRAVO_4.0e9135a6.jpg";